<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Virtuelles Gerät anlegen"}}</h4>
</div>
<div class="modal-body">
{{#if errors.error}}
    <div class="alert alert-danger">{{errors.error}}</div>
{{/if}}

{{#WIZARD wizardContext}}
    {{#if filterConfig.isFilter}}
    {{#WIZARD-TAB 'Filter'}}
        {{{DEVICE-FILTER filterConfig}}}
    {{/WIZARD-TAB}}
    {{/if}}
    {{#WIZARD-TAB 'Devices'}}
        {{{DEVICE-SELECT filterConfig}}}
    {{/WIZARD-TAB}}
    {{#WIZARD-TAB 'Series'}}
        {{#each series}}
            <div class="row" data-idx="{{idx}}">
                <div class="col-xs-12 col-sm-6 col-md-3 m-t-5">
                    {{#SELECT value}}
                    <select class="selectpicker js-edit-series js-value" data-style="btn-white">
                        {{#each ../availableValues}}
                            <option value="{{id}}">{{name}}</option>
                        {{/each}}
                    </select>
                    {{/SELECT}}
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 m-t-5">
                    {{#SELECT aggregation}}
                    <select class="selectpicker js-edit-series js-aggregation {{#if isVirtual}}disabled{{/if}}" data-style="btn-white"
                      {{#if isVirtual}}disabled{{/if}}
                    >
                        {{#each ../aggregations}}
                            <option value="{{id}}">{{name}}</option>
                        {{/each}}
                    </select>
                    {{/SELECT}}
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 m-t-5">
                    <input type="text" class="form-control js-edit-series js-name" placeholder="{{TR 'Bezeichnung des Wertes'}}" value="{{name}}">
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 m-t-5">
                    <button class="btn btn-white pull-right js-delete-series">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
                {{#if isDuplicate}}
                <div class="m-t-5 col-xs-12 col-md-9">
                    <div class="alert alert-danger">
                        {{TR 'In einem virtuellen Gerät müssen alle Werte und Aggregationsfunktionen unterschiedlich sein.'}}
                    </div>
                </div>
                {{/if}}

            </div>
        {{/each}}
        <div class="row m-b-5">
            <div class="col-xs-12">
                <button class="btn btn-white pull-right js-add-series">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
        </div>
    {{/WIZARD-TAB}}
    {{#WIZARD-TAB 'VirtualDevice'}}
        <div class="row m-b-20">
            <div class="col-xs-12">
                <label for="vd-name-input" class="control-label">{{TR "Gerätename"}}</label>
                <input type="text" class="form-control js-vd" id="vd-name-input" placeholder="{{TR 'Gerätename'}}" value="{{name}}" maxlength="255">
            </div>
        </div>
    {{/WIZARD-TAB}}
{{/WIZARD}}

<div class="modal-footer">
    {{{WIZARD-BUTTONS wizardContext}}}
</div>
